// extracted by mini-css-extract-plugin
export default {"select":"select_style_select__E0TQ9","border":"select_style_border__n9Keh"};